/**
 * Created by Rodrigo Quesada on 29/03/17.
 */
import {PersonalInfo} from './personal-info.class';
import {CvModel} from '../model/cv.model';
import {WorkEntry, WorkType} from './work-entry.class';
import {EducationEntry, EducationType} from './education-entry.class';
import {LicensesAndCertificationsInfo} from './licenses-and-certifications.class';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

export class CvDocument {

    readonly personalInfo: PersonalInfo;
    readonly education: EducationEntry[];
    readonly work: WorkEntry[];
    readonly licensesAndCertifications: LicensesAndCertificationsInfo;

    readonly initialized$: Observable<boolean>;

    constructor(cvdm: CvDocument.InjectedMembers, cvModel: CvModel) {
        this.personalInfo = new PersonalInfo(cvModel.personalInfo);

        const education = cvModel.education;
        this.education = (<EducationType[]>[education.premedical,
            education.ecfmg,
            education.medical])
            .concat(
                education.other,
                education.internship,
                education.residency,
                education.fellowshipOrPreceptorship
            )
            .filter(it => !!it)
            .map(it => new EducationEntry(it))
            .sort((a, b) => a.compareTo(b));

        const work = cvModel.work;
        this.work = (<(WorkType)[]>[work.military]).concat(work.work)
            .filter(it => !!it)
            .map(it => new WorkEntry(it))
            .sort((a, b) => a.compareTo(b));

        this.licensesAndCertifications = new LicensesAndCertificationsInfo(cvdm.lcim, cvModel.licensesAndCertifications);

        this.initialized$ = this.licensesAndCertifications.initialized$;
    }
}

// region Injection
export module CvDocument {
    @Injectable()
    export class InjectedMembers {
        constructor(readonly lcim: LicensesAndCertificationsInfo.InjectedMembers) {}
    }
}
// endregion




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/document/cv-document.class.ts